import { Components, Theme } from '@mui/material'

export const MuiDrawer: Components<Omit<Theme, 'components'>>['MuiDrawer'] = {
  defaultProps: {
    anchor: 'right',
  },
  styleOverrides: {
    paper: ({ theme }) => ({
      backgroundColor: theme.palette.bg.surface.default,
      backgroundImage: 'none', // MUI applies a default background image for Paper
      color: theme.palette.text.default,
    }),
    paperAnchorRight: {
      width: 'min(480px, 100vw)',
    },
  },
}
